import { useAnalytics } from '@medely/ui-kit';
import { useOTAMetadata } from '../useOTAMetadata';
import { useImpersonating } from '../useImpersonating';

export function useReleaseShiftEvent() {
  const analytics = useAnalytics();
  const otaMetadata = useOTAMetadata();
  const isImpersonating = useImpersonating();

  const trackReleaseShiftButtonClicked = (jobId?: number | null) => {
    analytics.track('Job Details - Release Shift Button - Clicked', {
      context: 'Job Details',
      subcontext: 'Release Shift Button',
      action: 'Clicked',
      job_id: jobId,
      impersonating: isImpersonating,
      ...otaMetadata,
    });
  };

  const trackReleaseOptionsModalViewed = (jobId?: number | null) => {
    analytics.track('Release Shift - Release Options Modal - Viewed', {
      context: 'Release Shift',
      subcontext: 'Release Options Modal',
      action: 'Viewed',
      job_id: jobId,
      impersonating: isImpersonating,
      ...otaMetadata,
    });
  };

  const trackReleaseShiftInsideModalClicked = (jobId?: number | null) => {
    analytics.track('Release Shift - Release Shift Button - Clicked', {
      context: 'Release Shift',
      subcontext: 'Release Shift Button',
      action: 'Clicked',
      job_id: jobId,
      impersonating: isImpersonating,
      ...otaMetadata,
    });
  };

  return {
    trackReleaseShiftButtonClicked,
    trackReleaseOptionsModalViewed,
    trackReleaseShiftInsideModalClicked,
  };
}
